export default "__VITE_ASSET__cee0b6f0__"